
$('#cart-widget .cart-widget-button').before('<span class="close pekarna">Zpět do pekárny</span>');
$('#cart-widget').append('<span class="close back">Zpět do obchodu</span>');

$('#cart-widget').prepend('<div class="h5">Váš nákupní košík<span class="close"></span></div>');



$(document).on(
    "click",
    "#cart-widget .close",
    function () {
        $("body").removeClass("user-action-visible cart-window-visible");
    },
);



$(document).ready(function () {
    updateFinalPrice();
});
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    updateFinalPrice();
});
document.addEventListener("ShoptetCartUpdated", function () {
    updateFinalPrice();
});


function updateFinalPrice() {
    if (!$('.popup-widget-inner+.finalPrice').length) {
        $('#cart-widget .popup-widget-inner').after('<div class="finalPrice"><span class="label">Celková cena:</span> <span class="value">0</span></div>');
    }
    var cartInfo = getShoptetDataLayer("cartInfo");
    if (!cartInfo) return;
    var currentValue = cartInfo.getNoBillingShippingPrice.withVat;
    currentValue = Math.abs(parseFloat(currentValue));
    $('.finalPrice .value').text(Number(currentValue).ShoptetFormatAsCurrency());
}
